<template lang="pug">
.img_slider
  template(v-if='imgs.length > 1')
    a.prev.arrow(@click='prev') &#10094;
    a.next.arrow(@click='next') &#10095;
  template(v-for='(img, index) in imgs')
    img.img_icon(v-show='img.show', :src='img.img', :alt='alt', :key='index')
  .slide-numbers(v-if='imgs.length > 1')
    span.dot(
      v-for='(img, index) in imgs',
      :class='{ active: img.show }',
      :key='index',
      @click='setImage(index)'
    )
</template>

<script>
export default {
  name: 'Slider',
  props: {
    imgs: {},
    alt: String,
  },
  methods: {
    setImage(index) {
      for (let i = 0; i < this.imgs.length; i++) {
        this.imgs[i].show = false;
      }
      this.imgs[index].show = true;
    },
    prev() {
      for (let i = 0; i < this.imgs.length; i++) {
        if (this.imgs[i].show === true) {
          this.imgs[i].show = false;
          if (i === 0) {
            this.imgs[this.imgs.length - 1].show = true;
          } else {
            this.imgs[i - 1].show = true;
          }
          return;
        }
      }
    },
    next() {
      for (let i = 0; i < this.imgs.length; i++) {
        if (this.imgs[i].show === true) {
          this.imgs[i].show = false;
          if (this.imgs.length - 1 === i) {
            this.imgs[0].show = true;
          } else {
            this.imgs[i + 1].show = true;
          }
          return;
        }
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/uikit/stylus/media'
.slide-numbers{
  text-align: center;
  position:absolute;
  bottom:1em;
  left:45%;
}
.dot{
  cursor: pointer;
  height: 10px;
  width: 10px;
  margin: 0 2px;
  background-color: rgba(204,204,204, 0.3);
  border-radius: 50%;
  display: inline-block;
}

.dot:hover, .active{
  background-color: rgb(204,204,204);
  height: 12px;
  width: 12px;
}
.dot:hover{
  box-shadow: 0 0 5px #fff;
}
.img_slider {
  position relative;
}
.img_icon
  width 100%
  max-width 100%
.prev, .arrow
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  margin: -1.5em .3em 0 .3em;
  padding: 1em;
  color: white;
  font-weight: bold;
  font-size: 1.2em;
  transition: 0.3s ease;
  border-radius: .5em;
  user-select: none;
  background-color:rgba(204,204,204, 0.3);
.arrow{
  display:inline;
  z-index: 1;
}
.next {
  right:0
}
.prev:hover, .next:hover{
  box-shadow: 0 0 5px #fff;
  border:1px solid #fff;
}
</style>



// WEBPACK FOOTER //
// Slider.vue?06caeac2